import objectToQueryString from '../helpers/objectToQueryString';
import get from '../helpers/get';

export const handleBadResponse = async (response, defaultMessage) => {
  let data;
  try {
    data = await response.json();
  } catch (e) {
    // ignore body parsing errors
  }
  const error = new Error(get(data, ['error', 'message']) || defaultMessage);
  error.status = response.status;
  throw error;
};

/* global fetch:false */
export default async (itemTypePlural, url, params, body, method = 'get') => {
  const qs = objectToQueryString(params) || '';

  const response = await fetch(`${url}?${qs}`, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': method === 'post' || method === 'put' ? 'application/json' : undefined,
    },
    body: body && JSON.stringify(body),
  });

  if (!response.ok) {
    await handleBadResponse(response, `Failed to fetch ${itemTypePlural}`);
  }

  return response.json();
};
